/** First-write DELETE payload for office cancel (T2-6714). */
export function buildOfficeCancelFirstWriteBody(
  formData: { reason: string; details: string },
  opts: { reasonValue: string; repostShift: boolean },
): { reason: string; details: string; repostShift?: boolean; shouldRepost: boolean } {
  const shouldRepost = opts.reasonValue === 'onBehalfOfTalent' && !!opts.repostShift;
  return {
    reason: formData.reason,
    details: formData.details,
    ...(shouldRepost ? { repostShift: true } : {}),
    shouldRepost,
  };
}
